import { MaxBrainLocation } from './location.model';

export class LocationCommand {
    name: string;

    constructor(location: MaxBrainLocation, public id?: string) {
        this.name = location.name;
    }
}
